module.exports = __webpack_public_path__ + "img/format_1.dda8cbc5.svg";